import { render, staticRenderFns } from "./startpage.vue?vue&type=template&id=ff5fae42"
import script from "./startpage.ts?vue&type=script&lang=ts&external"
export * from "./startpage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports